import React, { useState } from 'react';
import { DownloadIcon, CalendarIcon } from 'lucide-react';
import { MetricCard } from '../components/MetricCard';
import { BarChart } from '../components/charts/BarChart';
import { LineChart } from '../components/charts/LineChart';
import { PieChart } from '../components/charts/PieChart';
import { DateSelector } from '../components/DateSelector';
import { ViewAllButton } from '../components/ViewAllButton';
import { CreditCardIcon, SmartphoneIcon, WalletIcon, CoinsIcon } from 'lucide-react';
import { ChevronDownIcon } from 'lucide-react';
export const Revenue: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedZone, setSelectedZone] = useState('all');
  const [selectedWoreda, setSelectedWoreda] = useState('all');
  const [selectedKebele, setSelectedKebele] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedService, setSelectedService] = useState('all');
  const timeRanges = ['12 months', '3 months', '30 days', '7 days', 'Today'];
  const revenueData = Array.from({
    length: 12
  }, (_, i) => ({
    month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i],
    value: 40 + Math.random() * 50
  }));
  const topDepartments = [{
    name: 'Market',
    value: 14.8
  }, {
    name: 'Land',
    value: 11.3
  }, {
    name: 'Health',
    value: 9.7
  }, {
    name: 'Education',
    value: 4.5
  }, {
    name: 'Civil Registry',
    value: 2.4
  }];
  const topServices = [{
    name: 'Vehicle Tax Renewal',
    value: 8.2
  }, {
    name: 'Passport Application',
    value: 7.5
  }, {
    name: 'Driving License Renewal',
    value: 6.4
  }, {
    name: 'Birth Certificate',
    value: 3.8
  }, {
    name: 'Marriage Certificate',
    value: 3.1
  }];
  const paymentMethodDetails = [{
    name: 'Credit/Debit Card',
    value: 45,
    icon: <CreditCardIcon size={20} data-id="element-276" />,
    growth: '+12%',
    amount: '$19.2M'
  }, {
    name: 'Direct Debit',
    value: 25,
    icon: <div size={20} data-id="element-277" />,
    growth: '+8%',
    amount: '$10.7M'
  }, {
    name: 'Bank Transfer',
    value: 15,
    icon: <div size={20} data-id="element-278" />,
    growth: '+5%',
    amount: '$6.4M'
  }, {
    name: 'Mobile Money',
    value: 10,
    icon: <SmartphoneIcon size={20} data-id="element-279" />,
    growth: '+15%',
    amount: '$4.3M'
  }, {
    name: 'Cash',
    value: 5,
    icon: <CoinsIcon size={20} data-id="element-280" />,
    growth: '-2%',
    amount: '$2.1M'
  }];
  const handleViewAllDepartments = () => {
    console.log('View all departments clicked');
    alert('View all departments functionality would be implemented here');
  };
  const handleViewAllServices = () => {
    console.log('View all services clicked');
    alert('View all services functionality would be implemented here');
  };
  return <div data-id="element-281">
      <div className="flex justify-between items-center mb-6" data-id="element-282">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-283">Revenue</h2>
        <button className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-md text-sm" data-id="element-284">
          <DownloadIcon size={16} className="mr-2" data-id="element-285" />
          Download report
        </button>
      </div>
      <div className="mb-6" data-id="element-286">
        <div className="flex items-center space-x-4 flex-wrap gap-y-2" data-id="element-287">
          <div className="relative" data-id="element-288">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} data-id="element-289">
              <option value="all" data-id="element-290">All Regions</option>
              <option value="amhara" data-id="element-291">Amhara</option>
              <option value="oromia" data-id="element-292">Oromia</option>
              <option value="tigray" data-id="element-293">Tigray</option>
              <option value="snnpr" data-id="element-294">SNNPR</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-295" />
          </div>
          <div className="relative" data-id="element-296">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedZone} onChange={e => setSelectedZone(e.target.value)} data-id="element-297">
              <option value="all" data-id="element-298">All Zones</option>
              <option value="north" data-id="element-299">North Zone</option>
              <option value="south" data-id="element-300">South Zone</option>
              <option value="east" data-id="element-301">East Zone</option>
              <option value="west" data-id="element-302">West Zone</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-303" />
          </div>
          <div className="relative" data-id="element-304">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedWoreda} onChange={e => setSelectedWoreda(e.target.value)} data-id="element-305">
              <option value="all" data-id="element-306">All Woredas</option>
              <option value="woreda1" data-id="element-307">Woreda 1</option>
              <option value="woreda2" data-id="element-308">Woreda 2</option>
              <option value="woreda3" data-id="element-309">Woreda 3</option>
              <option value="woreda4" data-id="element-310">Woreda 4</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-311" />
          </div>
          <div className="relative" data-id="element-312">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedKebele} onChange={e => setSelectedKebele(e.target.value)} data-id="element-313">
              <option value="all" data-id="element-314">All Kebeles</option>
              <option value="kebele1" data-id="element-315">Kebele 01</option>
              <option value="kebele2" data-id="element-316">Kebele 02</option>
              <option value="kebele3" data-id="element-317">Kebele 03</option>
              <option value="kebele4" data-id="element-318">Kebele 04</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-319" />
          </div>
          <div className="relative" data-id="element-320">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedDepartment} onChange={e => setSelectedDepartment(e.target.value)} data-id="element-321">
              <option value="all" data-id="element-322">All Departments</option>
              <option value="market" data-id="element-323">Market</option>
              <option value="land" data-id="element-324">Land</option>
              <option value="health" data-id="element-325">Health</option>
              <option value="education" data-id="element-326">Education</option>
              <option value="civil" data-id="element-327">Civil Registry</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-328" />
          </div>
          <div className="relative" data-id="element-329">
            <select className="appearance-none bg-white border border-gray-200 rounded-md pl-3 pr-8 py-2 text-sm text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500" value={selectedService} onChange={e => setSelectedService(e.target.value)} data-id="element-330">
              <option value="all" data-id="element-331">All Services</option>
              <option value="tax" data-id="element-332">Vehicle Tax Renewal</option>
              <option value="passport" data-id="element-333">Passport Application</option>
              <option value="license" data-id="element-334">Driving License Renewal</option>
              <option value="birth" data-id="element-335">Birth Certificate</option>
              <option value="marriage" data-id="element-336">Marriage Certificate</option>
            </select>
            <ChevronDownIcon size={16} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-337" />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-338">
        <MetricCard title="Total Revenue" value="$42.7M" change={{
        value: '+8.3%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-340">
              Download report
            </a>} data-id="element-339" />
        <MetricCard title="Revenue Growth" value="8.3%" change={{
        value: '+2.1%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-342">
              Download report
            </a>} data-id="element-341" />
        <MetricCard title="Avg. Transaction Value" value="$348.52" change={{
        value: '+$122.74',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-344">
              Download report
            </a>} data-id="element-343" />
        <MetricCard title="Failed Payments" value="2.3%" change={{
        value: '-0.5%',
        positive: true
      }} footer={<a href="#" className="text-blue-500 text-sm" data-id="element-346">
              Download report
            </a>} data-id="element-345" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-347">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-348">
          <div className="flex justify-between items-center mb-6" data-id="element-349">
            <h3 className="text-lg font-medium" data-id="element-350">Top 5 Earning Departments</h3>
            <div className="flex items-center" data-id="element-351">
              <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-352" />
              <ViewAllButton onClick={handleViewAllDepartments} data-id="element-353" />
            </div>
          </div>
          {topDepartments.map((dept, index) => <div key={dept.name} className="mb-4 last:mb-0" data-id="element-354">
              <div className="flex justify-between items-center mb-1" data-id="element-355">
                <span className="text-sm font-medium" data-id="element-356">{dept.name}</span>
                <span className="text-sm font-medium" data-id="element-357">${dept.value}M</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-358">
                <div className="bg-blue-500 h-2.5 rounded-full" style={{
              width: `${dept.value / topDepartments[0].value * 100}%`
            }} data-id="element-359"></div>
              </div>
            </div>)}
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-360">
          <div className="flex justify-between items-center mb-6" data-id="element-361">
            <h3 className="text-lg font-medium" data-id="element-362">Top 5 Earning Services</h3>
            <div className="flex items-center" data-id="element-363">
              <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-364" />
              <ViewAllButton onClick={handleViewAllServices} data-id="element-365" />
            </div>
          </div>
          {topServices.map((service, index) => <div key={service.name} className="mb-4 last:mb-0" data-id="element-366">
              <div className="flex justify-between items-center mb-1" data-id="element-367">
                <span className="text-sm font-medium" data-id="element-368">{service.name}</span>
                <span className="text-sm font-medium" data-id="element-369">${service.value}M</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-370">
                <div className="bg-blue-500 h-2.5 rounded-full" style={{
              width: `${service.value / topServices[0].value * 100}%`
            }} data-id="element-371"></div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-372">
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-373">
          <div className="flex justify-between items-center mb-6" data-id="element-374">
            <div data-id="element-375">
              <h3 className="text-lg font-medium" data-id="element-376">
                Payment Method Distribution
              </h3>
              <p className="text-sm text-gray-500" data-id="element-377">
                Transaction volume by payment type
              </p>
            </div>
            <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm hover:bg-blue-50 transition-colors duration-200" data-id="element-378">
              Download Report
            </button>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-379">
            <div data-id="element-380">
              <PieChart data={paymentMethodDetails} nameKey="name" dataKey="value" colors={['#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe']} data-id="element-381" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-382">
              <div className="space-y-4" data-id="element-383">
                {paymentMethodDetails.map((method, index) => <div key={method.name} className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200" data-id="element-384">
                    <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-50 text-blue-500" data-id="element-385">
                      {method.icon}
                    </div>
                    <div className="ml-4 flex-1" data-id="element-386">
                      <div className="flex items-center" data-id="element-387">
                        <span className="font-medium text-gray-900" data-id="element-388">
                          {method.name}
                        </span>
                        <span className={`ml-2 text-sm ${method.growth.startsWith('+') ? 'text-green-500' : 'text-red-500'}`} data-id="element-389">
                          {method.growth}
                        </span>
                      </div>
                      <div className="flex items-center mt-1" data-id="element-390">
                        <div className="flex-1" data-id="element-391">
                          <div className="flex items-center" data-id="element-392">
                            <div className="flex-1 h-1.5 bg-gray-200 rounded-full" data-id="element-393">
                              <div className="h-1.5 bg-blue-500 rounded-full" style={{
                            width: `${method.value}%`
                          }} data-id="element-394"></div>
                            </div>
                            <span className="ml-2 text-sm text-gray-500" data-id="element-395">
                              {method.value}%
                            </span>
                          </div>
                        </div>
                        <span className="ml-4 text-sm font-medium text-gray-900" data-id="element-396">
                          {method.amount}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-397">
          <div className="flex justify-between items-center mb-6" data-id="element-398">
            <h3 className="text-lg font-medium" data-id="element-399">Revenue Trend Over Time</h3>
            <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm" data-id="element-400">
              Download Report
            </button>
          </div>
          <div className="mb-4" data-id="element-401">
            <div className="flex space-x-4" data-id="element-402">
              {timeRanges.map(range => <button key={range} className={`px-4 py-1.5 text-sm rounded-md ${range === '12 months' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-403">
                  {range}
                </button>)}
            </div>
          </div>
          <LineChart data={revenueData} xKey="month" yKey="value" data-id="element-404" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-405">
        <div className="flex justify-between items-center mb-6" data-id="element-406">
          <h3 className="text-lg font-medium" data-id="element-407">
            Outstanding/Failed Payment Tracking
          </h3>
          <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm" data-id="element-408">
            Download Report
          </button>
        </div>
        <div className="mb-6" data-id="element-409">
          <div className="flex space-x-4" data-id="element-410">
            <button className="px-4 py-1.5 text-sm rounded-md bg-blue-50 text-blue-600" data-id="element-411">
              12 months
            </button>
            <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-412">
              30 days
            </button>
            <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-413">
              7 days
            </button>
            <button className="px-4 py-1.5 text-sm rounded-md text-gray-600 hover:bg-gray-100" data-id="element-414">
              24 hours
            </button>
          </div>
        </div>
        <div className="mb-6" data-id="element-415">
          <h4 className="text-sm font-medium text-gray-600 mb-4" data-id="element-416">
            Payment Failure Rates Over Time
          </h4>
          <LineChart data={Array.from({
          length: 12
        }, (_, i) => ({
          month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i],
          value: 600 + Math.random() * 200
        }))} xKey="month" yKey="value" data-id="element-417" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-418">
          <div data-id="element-419">
            <h4 className="text-sm font-medium text-gray-600 mb-2" data-id="element-420">
              Outstanding Payments
            </h4>
            <p className="text-3xl font-bold text-orange-500" data-id="element-421">$458.2M</p>
          </div>
          <div data-id="element-422">
            <h4 className="text-sm font-medium text-gray-600 mb-2" data-id="element-423">
              Failed Payments
            </h4>
            <p className="text-3xl font-bold text-red-500" data-id="element-424">$32.6M</p>
          </div>
        </div>
      </div>
    </div>;
};